var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandShapes2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 132",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.306 79.3513V132.165H62.1743L39.126 109.025C36.7483 106.635 35.4097 103.402 35.4097 100.035V12.9348C35.4014 1.5708 49.1526 -4.11115 57.1755 3.94006L132.306 79.3513Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandShapes2);
export default __webpack_public_path__ + "static/media/BrandShapes2.f432c22b27f6a88f573f33289c1d4e08.svg";
export { ForwardRef as ReactComponent };